// Logique de GRILLE de l'éditeur, extraite de client/editor.ts pour être testable hors canvas/DOM
// (persistance / redimensionnement d'un niveau). Pur : aucune dépendance DOM.

/** Normalise une source en `rows` lignes de `cols` caractères (comble/tronque au besoin) —
 *  conserve le coin haut-gauche, comble le neuf en '.'. Sert au chargement ET au redimensionnement. */
export function normalize(src: string[] | undefined, cols: number, rows: number): string[] {
  const out: string[] = []
  for (let r = 0; r < rows; r++) {
    const line = src?.[r] ?? ''
    out.push((line + '.'.repeat(cols)).slice(0, cols))
  }
  return out
}

/** Borne une dimension chargée dans [1, max] (défensif : un niveau hors-normes ne casse pas l'éditeur). */
export const clampDim = (v: number, max: number): number => Math.max(1, Math.min(max, v))
